import { createContext, useMemo, useReducer } from 'react';

import { loaderReducer } from './reducer/LoaderReducer';
import { initialState } from './store/LoaderStore';

export const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [state, dispatch] = useReducer(loaderReducer, initialState);

  const loaderProviderValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return <LoaderContext.Provider value={loaderProviderValue}>{children}</LoaderContext.Provider>;
};
